import PortalIdParser from 'PortalIdParser';
import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
const fetchInAppEligibleBreezeIntelligenceProducts = () => {
  const url = '/eligibility-engine/v4/breeze/in-app';
  return http.post(url, {
    data: {
      portalId: PortalIdParser.get()
    }
  });
};
const fetchPublicEligibleBreezeIntelligenceProducts = ({
  countryCode,
  selectedApiNames
}) => {
  const url = '/eligibility-engine/v4/breeze/public';
  return noAuthHttp.post(url, {
    data: {
      countryCode,
      selectedApiNames
    }
  });
};
export const GET_ELIGIBLE_BREEZE_SKUS = registerQuery({
  fieldName: 'eligibleBreezeSkus',
  args: ['noAuth', 'apiNames', 'countryCode'],
  fetcher({
    noAuth,
    apiNames = [],
    countryCode = 'US'
  }) {
    return (noAuth ? fetchPublicEligibleBreezeIntelligenceProducts({
      selectedApiNames: apiNames,
      countryCode
    }) : fetchInAppEligibleBreezeIntelligenceProducts()).then(response => response.eligibleBreezeSkus.sort());
  }
});